import { createContext } from "react";

type PathCtx = { total: number };
const PathContext = createContext<PathCtx | null>(null);

type NodeCtx = { x: number; y: number };

const NodeContext = createContext<NodeCtx | null>(null);

export { PathContext, NodeContext };
